import { apiService } from '@/services/APIService';
import Centrifuge from 'centrifuge';
import SockJS from 'sockjs-client';

export default {
  name: 'centrifuge',
  namespaced: true,
  state: {
    connects: {},
    channels: {},
    nofiticationCentrifuge: null,
    subscribers: {},
  },
  getters: {
    getChannel: (state) => (name) => state.channels[name],
  },
  actions: {
    async connect({ commit, dispatch }, url) {
      const response = await apiService.get(
        url,
      );
      const { data } = response.data;

      commit('ADD_CONNECT', data);
      dispatch('subscribe', { id: data.id, channel: data.channel });
      return data;
    },

    async connectNotifications({ commit }) {
      const response = await apiService.post('/auth/centrifuge');
      await commit('SET_NOTIFICATION_CENTRIFUGE', response.data.data);
    },

    subscribe({ state }, { id, channel, fn }) {
      state.connects[id].subscribe(channel, fn);
    },

    clearSusbcribers({ commit }) {
      commit('CLEAR_SUBSCRIBERS');
    },

    subscribeNotifications({ state, commit }, data) {
      if (!state.subscribers[data.channel]) {
        const subsciber = state.nofiticationCentrifuge.subscribe(data.channel, data.fn);
        commit('ADD_SUBSCRIBER', { channel: data.channel, subsciber });
      }
    },
  },
  mutations: {
    ADD_CONNECT(state, data) {
      const centrifugo = new Centrifuge(data.url, {
        sockjs: SockJS,
        onPrivateSubscribe: () => { },
      });
      // const centrifugo = new Centrifuge(data.url, {
      //   sockjs: SockJS,
      //   onPrivateSubscribe: () => { },
      //   async onRefresh(ctx, cb) {
      //     const response = await apiService.get(
      //       `${process.env.VUE_APP_API_URL}/friend-teams/1/chat`,
      //     );
      //     console.log(response.data);
      //     cb(response.data);
      //   },
      // });

      centrifugo.setToken(data.token);
      centrifugo.connect();
      state.connects[data.id] = centrifugo;
    },
    SET_NOTIFICATION_CENTRIFUGE(state, data) {
      const centrifugo = new Centrifuge(data.url);
      centrifugo.setToken(data.token);
      centrifugo.connect();
      state.nofiticationCentrifuge = centrifugo;
    },
    ADD_SUBSCRIBER(state, data) {
      state.subscribers[data.channel] = data.subsciber;
    },
    CLEAR_SUBSCRIBERS(state) {
      Object.keys(state.subscribers).forEach((subsciber) => {
        state.subscribers[subsciber].unsubscribe();
      });

      state.subscribers = {};
    },

  },
};
